import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const additionalFieldPresetsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'additionalFieldPresets'] as const;

  return createQueryKey({
    all: key,
    id: (itemId: QueryKeyParam) =>
      createQueryKey({
        all: [...key, itemId] as const,
        detail: [...key, itemId, 'detail'] as const,
      }),
  });
};

export { additionalFieldPresetsKeys };
